import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73f6e9d8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=73f6e9d8&lang=stylus&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=73f6e9d8&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f6e9d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f6e9d8')) {
      api.createRecord('73f6e9d8', component.options)
    } else {
      api.reload('73f6e9d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73f6e9d8&scoped=true&", function () {
      api.rerender('73f6e9d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video/index.vue"
export default component.exports